import { AfterViewInit, Directive, ElementRef, Optional, Renderer2 } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ridango/core';

@Directive({
    selector: '[ridangoAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        @Optional() private ionModal: IonModal
    ) {}

    ngAfterViewInit() {
        if (this.ionModal) {
            this.ionModal.didPresent.pipe(take(1)).subscribe(() => {
                this.focusElement();
            });
        } else {
            this.focusElement();
        }
    }

    private focusElement() {
        setTimeout(() => {
            const nativeButton = this.el.nativeElement?.shadowRoot?.querySelector('button');
            if (Capacitor.getPlatform() === Platform.ANDROID && nativeButton) {
                this.renderer.setAttribute(nativeButton, 'tabindex', '1');
                nativeButton.focus();
            } else if (Capacitor.getPlatform() === Platform.IOS) {
                this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '1');
                this.el.nativeElement.focus();
            } else {
                this.el.nativeElement.focus();
            }
        }, 50);
    }
}
